import React from 'react'
import styled from 'styled-components'

interface PrettierJsonProps {
    json: Record<string, unknown>
}

const PrettierJson: React.FC<PrettierJsonProps> = ({ json }: PrettierJsonProps) => {
    if (typeof json === 'object' && json !== null) {
        return (
            <DataList>
                {Object.entries(json).map(([key, value]) => (
                    <li key={key}>
                        <strong>{key}:</strong>{' '}
                        {typeof value === 'object' ? <PrettierJson json={value} /> : String(value)}
                    </li>
                ))}
            </DataList>
        )
    }

    return <span>{json}</span>
}

export default PrettierJson

const DataList = styled.ul`
    margin-top: 16px;

    li {
        font: 14px / 20px var(--font-regular);
    }
`
